import CurrencySymbols from '../constants/CurrencySymbols';

export interface Options {
  toRound?: boolean;
  toISO?: boolean;
}

/**
 * @deprecated use `ha/i18n`/`@ha/intl`' `formatCurrency(amount, currency, CurrencyFormat.PRESET)`
 */
export default function formatPrice(
  rawPrice: number,
  currency: string,
  { toRound, toISO }: Options = {},
): string {
  const price = toRound
    ? Math.round(rawPrice / 100)
    : Math.floor(rawPrice / 100);

  if (toISO) {
    return `${currency} ${price}`;
  }

  const currencySymbol = CurrencySymbols[currency] || `${currency} `;

  return `${currencySymbol}${price}`;
}
